export const TRIAL_PAGES_V3B = 'v3b';
